import axiosInstance from './axiosInstance';

/**
 * A customer's cars, and adding one.
 *
 * 🔑 Both exist because a vehicle has to be NOMINATED before a job can be raised —
 * job.vehicle_id is NOT NULL — and an imported invoice knows its customer but not their
 * car. The customer lookup endpoint already returns vehicles, but only for a search by
 * phone or name, which is no use when you hold a record that already names its customer.
 */

/** This customer's cars, ordered by rego so a picker does not reshuffle. */
export const getCustomerVehiclesApi = async (customerUuid) => {
    const response = await axiosInstance.get(`/customers/${customerUuid}/vehicles`);
    return response.data;
};

/**
 * Add a car knowing only its plate.
 *
 * ⚠️ Rego alone is deliberate — it is what the person has, typed off the paperwork.
 * Make, model and year are optional and fall back to placeholders the display already
 * hides, so the car shows as its plate rather than "0 Unknown Unknown (ABC123)".
 */
export const addCustomerVehicleApi = async (customerUuid, { regoNumber, make, model, year } = {}) => {
    const response = await axiosInstance.post(`/customers/${customerUuid}/vehicles`, {
        regoNumber, make: make || null, model: model || null, year: year || null,
    });
    return response.data;
};
